import React from 'react'
import styled from 'styled-components'
import { useHistory } from 'react-router'
import routes from 'src/routes'
import { SIZES } from 'src/styles/theme'
import { SvgIcon } from './shared/SvgIcon'
import { SvgType } from './shared/SvgIcon/SvgIcon'

const BackBtn = styled.div`
    display: flex;
    align-items: center;
    cursor: pointer;
    color: #FFF;
    span {
      transition: all 300ms ease;
      display: block;
      margin-left: 16px;
    }
    &:hover {
      svg > path {
        transition: all 300ms ease;
        fill: #44ABE2;
      }
      span {
        color: #44ABE2;
        margin-left: 28px;
      }
    }
  ${SIZES.mobile} {
    span {
      margin-left: 8px;
    }
    svg {
      height: 25px !important;
    }
    &:hover {
      svg > path {
        transition: all 300ms ease;
        fill: #44ABE2;
      }
      span {
        color: #44ABE2;
      }
    }
  }
`

export default function BackToHomeButton() {
  const history = useHistory()

  const backHome = () => {
    history.push(routes.lobby)
  }
 
  return (
    <BackBtn onClick={backHome}>
      <SvgIcon type={SvgType.LEFTARROW} />
      <span className='font-weight-bolder'>BACK</span>
    </BackBtn>
  )
}
